import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=0d5a6788&scoped=true"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=0d5a6788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a6788",
  null
  
)

export default component.exports